//Reducer for loading filter data options
import moment from 'moment';
const filtersDataReducerDefaultState = {
    minDate  : moment.utc().subtract(1 ,'month').format('YYYY-MM-DD'),
    maxDate  : moment.utc().format('YYYY-MM-DD'),
    isLoaded : false,
    isErrors : false
};

export default (state = filtersDataReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_IS_LOADED':
            return {
                ...state,
                isLoaded : action.isLoaded
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/Reducers/filtersData.js